import { getLocale } from "@/data/regionInfo";
import { external3DScene } from '@/mixins/external3DScene';
import Vue from "vue";

export default Vue.extend({
  mixins: [external3DScene],
  data() {
    return {
      imageUrl: '',
      showSpinner: true
    }
  },
  computed: {
    pdm() {
      return this.$store.state.utils.pdm;
    },
    translations() {
      return (this.$store).state.translations.data;
    },
    enableFavoritesModal() {
      return this.$store.state.utils.configuration.enableNewFavoritesModal;
    },
    enableSnapshotService() {
			return this.$store.state.utils.configuration.enableSnapshotService;
		},
    canvasActive() {
      return this.$store.getters["utils/canvasActive"];
    }
  },
  methods: {
    hideSpinner(hide) {
      this.showSpinner = !hide;
    },
    setSnapShotImages(data) {
      const productImage = data.fileUrl;
      this.$store.commit('modals/SET_FAVORITES_PRODUCT_IMAGE', {
        recipeId: productImage.split("/")[5],
        data: productImage
      });
      this.imageUrl = productImage;
    },
    getProductImage({ recipe_id }) {
      const productImages = this.$store.state.modals.productImages.favorites;
      if (productImages[recipe_id]) {
        this.imageUrl = productImages[recipe_id];
        this.hideSpinner(true);
        return;
      }

      const { pdm } = this.$store.state.utils;
      const featuredView = pdm?.product_images?.featured_views?.favorites ?? { view: "checkerboard_creator", size: "md" }
      
      if(this.enableSnapshotService && !this.canvasActive) {
        this.initExternal3Dscene({domEl: "snapshot-image-scene", snapshotSize: "md", snapshotView: "checkerboard_creator", showSnapShot: true});
			} else if(!this.enableSnapshotService) {
        this.$store.dispatch('ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE_ID', {
          recipe_id,
          locale: getLocale(),
          type: 'customizer',
          ...featuredView
        })
        .then(data => {
          const productImage = data[`${featuredView.view}_view`][featuredView.size];
          this.$store.commit('modals/SET_FAVORITES_PRODUCT_IMAGE', {
            recipeId: recipe_id,
            data: productImage
          });
          this.imageUrl = productImage;
        });
      }
    },
  },
  created() {
    this.$eventBus.$on("snapshot-complete", this.setSnapShotImages);
  },
  beforeDestroy() {
    this.$eventBus.$off("snapshot-complete")
  }
});
